// extracted by mini-css-extract-plugin
export default {"bodyContainer":"RootLayout_bodyContainer__WK+23"};